import { LOCALES } from '../locales';

const HebrewLanguage = {
    [LOCALES.HEBREW]: {
        'hello': 'שלום',
        'homepage': 'דף ראשי',
        'username' : 'שם משתמש',
        'password' : 'סיסמה',
        'newpassword' : ' סיסמה חדשה   ',
        'confirm-newpassword' : ' אימות סיסמה חדשה   ',
        "bisharat" : 'בשאראת',
        'email' : 'דוא"ל',
        'full-name' : 'שם מלא',
        'phone-num' : 'מספר סלולרי',
        'new-phone-num' : '   מספר הסלולרי החדש   ',
        'bisharatfamily':'משפחת בשאראת',
        'permissions' : 'הרשאות',
        'familytree':' עץ המשפחה',
        'loading-family-tree':'טוען את עץ המשפחה...',
        'gallery':' גלריה ',
        'historical-info':'   מידע היסטורי  ',
        'about-us':'   מי אנחנו   ',
        'login':'התחברות',
        'login-now':' התחברות ',
        'logout':'התנתק',
        'already-logged' : '   : כבר מחובר במערכת   ',
        'click-to-activate' : '   לחץ להפעלת החשבון   ',
        'activated' : 'חשבונך הופעל הצלחה',
        'not-activated' : '   הפעלת חשבון נכשלה ',
        'adminboard' : 'דף ניהול',
        'user-pass-incorrect' : "שם משתמש או סיסמה אינם נכונים",
        'my-profile' : "   הפרופיל שלי  ",
        'for-more-contact' : ' לעוד מידע ובירורים, נא ליצור קשר',
        'contact-us' : "    צור קשר איתנו ",
        'click-here' : "  לחץ כאן  ",
        'read-more' : "  קרא עוד   ",
        'specify' : ' נא לפרט עוד ',
        "send" : 'שלח',
        'alert-email-sent' : 'אימייל ישלח לדו"אל שלך כדי להפעיל חשבון',
        'email-not-validated' : 'דוא"ל אינו מתאים  ',
        'mail-sent-success' : ' אימייל נשלח בהצלחה',
        'username-not-validated' : '  שם משתמש אינו יכול להכיל רווחים ',
        'username-not-available' : '   שם משתמש אינו מתאים  ',
        'name-not-appropriate' : 'שם אינו מתאים',
        'password-not-appropriate' : ' סיסמה אינה מתאימה',
        'not-appropriate' : 'שדה אינו מתאים  ',
        'password-more-than-8' : 'סיסמה חייבת להכיל יותר מ8 אותיות',
        'numbers-only' : 'מספרים בלבד  ',
        'phone-10-digits' : 'מםפר סלולרי 10 ספרות ',
        'phone-example' : 'דוגמה : 0505123123',
        'some-instructions' : '  טיפים והדרכה לצפיית עץ המשפחה בצורה טובה יותר ',
        'members-entrance' : 'הכניסה מותנת בהרשאות משפחה',  
        'use-chrome' : '     מומלץ להשתמש בדפדפן Chrome ',
        'scroll-sides' : '  אפשרות גלילה ימינה/שמאלה    ',
        'click-to-open' : 'לחץ על השם לפתוח פרופיל אישי שלו ',
        'see-full-profile' : 'יש אפשרות דרך הפרופיל האישי לפתוח עץ אחר שמתחיל מאותו בן אדם',
        'add-partner-succesfully' : ' הוספה בוצעה בהצלחה',
        'last-update' : 'עדכון אחרון',
        'next-update' : '  העדכון הבא   ',
        'maaloul-village' : " כפר מעלול ",
        'maaloul-village-zochrot' : " מעלול מאתר זוכרות ",
        'click-to-download-book' : " תלחץ להורדה/קריאה חוברת",
        'welcome' : "ברוכים הבאים",
        'mandatory' : "שדה חובה",
        'join-now' : " הצטרפו עכשיו",
        'join' : 'הצטרף',
        "request-permission-bish" : "נא לכנס ל-'הפרופיל שלי' על מנת לבקש הרשאות המשפחה כדי לראות עץ המשפחה ותכנים אחרים ",
        'msg-subject' : ' הנושא המכתב',
        'msg-content' : ' תוכן המכתב',
        "activities" : " אירועים וחגיגות ",
        'notifications' : "התראות",
        'site-under-development': "אתר זה עדיין חדש ומתפתח ",
        'welcoming-suggestions' : "תרגישו חופשי לתת רעיונות והצעות  ",
        "too-much-tries" : " הרבה נסיונות ללא הצלחה - בבקשה צור איתנו קשר להפעלת החשבון ",
        "too-much-tries-change-number" : " הרבה נסיונות ללא הצלחה - בבקשה צור איתנו קשר     ",
        "number-changed-successfully" : "  מספר טלפון עודכן בהצלחה    ",
        "User-phone-confirmed" : "  מספר טלפון אושר.. המערכת בודקת את זהותך ובקרוב תקבל הרשאות משפחה ",
        "back-to-main" : '  לדף הבית ',
        'pagenotfound' : '  דף לא נמצא  ',
        'back' : 'חזרה',
        "request-family-permissions" : '  בקשת הרשאות משפחה  ',
        "family-per-content" : "תוכן זה צריך הרשאות מיוחדות למשפחה ",
        "restore-user-pass" : ' שחזור שם משתמש או סיסמה',
        'check-ur-namil' : 'נא לבדוק את האימייל שלך להפעלת חשבון',
        "maaloul-parag-first" : "כפר פלסטיני בגליל התחתון, נכבש וכל תושביו גורשו ב 1948. ממוקם כ- 12 קילומטר מערבית לנצרת וכ- 30 קילומטר דרומית לחיפה. ממולו, שני קילומטר דרומה, מעבר לכביש הראשי נצרת חיפה, שכן הכפר הפלסטיני אלמג'ידל, ששרידיו נמצאים היום בתוך מגדל העמק. ייתכן והכפר מעלול הוקם על אתר הכפר היהודי רומאי מהלול, שהיה באותה תקופה שייך לספוריה. הצלבנים נתנו לכפר שם מאעולא.",
        "maaloul-parag-second" : "  מעלול עמד על גבעה בגובה 270 מטר מעל פני הים. ואדי אלחלבי (במקורות מסויימים נקרא ואדי אלספסאף) שימש גבול בין אדמות אלמג'ידל לאדמות מעלול. המעיין עין אלבַּסּ נמצא בקצה הצפון מזרחי של הכפר והמעיין הראשי, עין אלבַּלַד, נמצא צפונית מערבית לו.",
        'check-sms-req' : "תודה, בקשת הצטרפותך בטיפול",
        'code' : ' קוד אימות',
        'verify-code' : '  לאימות הקוד  ',
        'tries' : 'נסיונות',
        "youve" : "נשארו",
        'changepassword' : '  שינוי סיסמה  ',
        'modifyphone' : '   שינוי מספר טלפון  ',
        'newphone-used' : '  מספר טלפון בשימוש  ',
        'checkphone' : 'נא לוודא מספר טלפון לפני שליחת הבקשה ',
        'sendsms': ' לצורך אימות, ישלח הודעה עם קוד אימות   ',
        'oldpass-notcorrect' : ' סיסמה לא נכונה ',
        'newpass-notsimilar' : '   הסיסמה לא מאומתת  ',
        'success-change-pass' : 'סיסמה שונתה בהצלחה',
        'link-unavailable' : ' לינק שגוי',
        'notif' : 'התראה',
        'publishdate' : '  תאריך פרסום',
        'activity' : 'פעילות',
        'moredetails' : 'עוד פרטים',
        "activity-link" : 'קישור לפעילות',
        "activity-date" : ' תאריך הפעילות    ',
        "this-day-activity" : 'פעיליות היום הזה',
        'pick-date-act' : 'בחר תאריך לראות הפעיליות',
        "oncoming-act" : 'הפעיליות הבאות',
        "name" : "שם",
        "father-name" : 'שם האב  ',
        "mother-name" : ' שם האם ',
        "family-name" : '  משפחה  ',
        "address" : 'כתובת',
        "partner" : 'בן/בת זוג',
        'children' : 'ילדים',
        "showPartner" : 'פרופיל בן/בת הזוג',
        "addPartner" : 'הוספת בן/בת הזוג',
        "birthdate" : 'תאריך לידה ',
        "gender" : 'מין',
        'notfound' : 'אין מידע ',
        'fa-tree-person' : "עץ משפחה אישי   ",
        "edit" : 'עריכה',
        "add-child" : 'הוספת ילד ',
        "profile-pic" : 'תמונת פרופיל  ',
        "edit-profile-pic" : ' שינוי תמונת פרופיל    ',
        "alive" : "? עדיין בחיים  ",
        "yes" : 'כן',
        "no" : 'לא',
        "married" : "נשוי",
        "not-married" : " לא נשוי ",
        "status-fam" : '  מצב משפחתי ',
        'identity' : ' תעודת זהות',
        "male" : 'זכר',
        "female" : 'נקבה',
        'thanks-for-donation' : ' תודה רבה  ',
        'donation-text' : '  בתמיכתך נמשיך לצמוח ',

    }
}

export default HebrewLanguage;